import * as React from "react";
import styled, { css } from "styled-components";
import { TomatoCardItem } from "./TomatoCard";
import { getGap, getTomatoWidth, getTomatoCol } from "./utils";
export const GridMoreBaseBox = styled.section `
	width: inherit;
	margin: 0 auto;
	display: grid;
	width: 1190px;
	${(props) => {
    const { gridCol = 5, gridGap = 10 } = props;
    return css `
			grid-gap: ${gridGap}px;
			grid-template-columns: repeat(${gridCol}, 1fr);
		`;
}}
`;
export const ProductCards = (props) => {
    const { col = 5, products, typeUI, posterRatio, placeholderBg } = props;
    if (!products) {
        return null;
    }
    return (React.createElement(GridMoreBaseBox, { gridCol: getTomatoCol(col), gridGap: getGap(typeUI) }, products.map((ele, index) => {
        return (React.createElement(TomatoCardItem, { imgWidth: getTomatoWidth(col), product: ele, key: `${ele === null || ele === void 0 ? void 0 : ele.gpid}_${index}`, posterRatio: posterRatio, placeholderBg: placeholderBg }));
    })));
};
